export function calculateTableWidth(widths = []) {
  return widths.reduce((acc, item) => acc + item, 0);
}
